// De vaste teksten van de widget: foutmeldingen, "opnieuw proberen", "even geduld".
//
// Waarom deze naast de teksten uit de database staan: alles wat de winkelier zelf kan aanpassen
// komt uit WidgetTranslate, maar een foutmelding moet er juist zijn op het moment dat de verbinding
// met de server weg is. Die kan dus niet uit de database komen. Besloten door Martijn, 13-09-2026.
//
// Deze opzet stond er al maar werd nergens geïmporteerd: i18next was ingesteld, er stonden
// vertaalbestanden klaar, en drie schermen haalden `t` op zonder het ooit te gebruiken. Sinds WI1
// (13-09-2026) wordt hij in src/index.js geladen en volgt hij de taal van de widget.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { zetVertaler } from './lib/woorden';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        // Staat een tekst niet in de taal van de widget, dan eerst Engels en dan Nederlands: een Duitse
        // gast leest liever Engels dan Nederlands. Nooit de sleutel zelf. (VERTALEN-WEBSITETALEN fase 2,
        // 29-09-2026, net als de server: een taal zonder tekst krijgt Engels.)
        fallbackLng: { nl: ['en'], default: ['en', 'nl'] },

        // De taal komt uit het adres van de widget, niet uit de browser van de gast: een Duitse
        // gast op een Nederlandse site hoort de taal te zien die de winkelier heeft ingesteld.
        // Daarom staat de taaldetectie van de browser er bewust niet in.
        lng: 'nl',

        // De 13 talen van de website (besluit 28-09-2026). Noors = Bokmål, code no.
        supportedLngs: ['nl', 'en', 'da', 'de', 'el', 'es', 'fi', 'fr', 'it', 'no', 'pl', 'pt', 'sv'],

        // translation: de foutmeldingen ("fouten.reservering-mislukt"); teksten: de vaste schermteksten
        // van de widgets, met de Nederlandse of Engelse tekst zelf als sleutel (zie lib/woorden.js).
        ns: ['translation', 'teksten'],
        defaultNS: 'translation',

        // Alleen aanzetten als je zelf zoekt waarom een tekst niet gevonden wordt; anders vult hij
        // de console van elke gast.
        debug: false,

        interpolation: { escapeValue: false },

        // Zonder dit blijft het scherm leeg zolang het vertaalbestand nog binnenkomt. Een lege
        // widget is erger dan een halve tel de terugvaltekst.
        // Opnieuw tekenen zodra een vertaalbestand binnen is, niet alleen bij een andere taal.
        react: { useSuspense: false, bindI18n: 'languageChanged loaded' },

        backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    });

// De taal van de widget doorgeven. Wordt aangeroepen zodra bekend is welke taal de winkelier heeft
// ingesteld of de gast heeft gekozen.
export function zetTaal(taalcode) {
    if (!taalcode) return;

    let kort = String(taalcode).trim().toLowerCase().split(/[-_]/)[0];

    // De tabel Language gebruikt voor een paar talen de landcode (DK, GR, SE); Noors kan als nb of nn komen.
    kort = { dk: 'da', gr: 'el', se: 'sv', nb: 'no', nn: 'no' }[kort] || kort;

    if (i18n.language !== kort) i18n.changeLanguage(kort);
}

// De vaste schermteksten (lib/woorden.js: vertaal/tekst/woord) lopen via i18next, namespace "teksten", met de
// tekst zelf als sleutel: punten en dubbele punten in een zin zijn dan geen scheidingstekens.
zetVertaler((tekst) => i18n.t(tekst, { ns: 'teksten', keySeparator: false, nsSeparator: false, defaultValue: tekst }));

export default i18n;
